import type { ReactElement } from "react";

import { Badge } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

const MarketingChannelsFilterTag = (): ReactElement => <Badge type="new">{translate("si.common.updated")}</Badge>;

export default MarketingChannelsFilterTag;
